package repdb

import com.ustadmobile.door.DoorDatabaseRepository
import com.ustadmobile.door.RepositoryConfig
import com.ustadmobile.door.RepositoryHelper
import com.ustadmobile.door.replication.DoorRepositoryReplicationClient
import com.ustadmobile.door.room.InvalidationTracker
import io.ktor.client.HttpClient
import kotlin.Any
import kotlin.IllegalStateException
import kotlin.Int
import kotlin.Long
import kotlin.String
import kotlin.Suppress
import kotlin.Unit
import kotlin.collections.List
import kotlinx.coroutines.flow.Flow

@Suppress("LocalVariableName", "PropertyName", "FunctionName", "ClassName")
public class RepDb_Repo(
  override val db: RepDb,
  dbUnwrapped: RepDb,
  override val config: RepositoryConfig,
) : RepDb(), DoorDatabaseRepository {
  public val context: Any
    get() = config.context

  private val _db: RepDb = dbUnwrapped

  private val _endpoint: String
    get() = config.endpoint

  public val _httpClient: HttpClient
    get() = config.httpClient

  public val _repositoryHelper: RepositoryHelper = RepositoryHelper(db, config)


  public val clientId: Long
    get() = config.nodeId

  override val dbName: String
    get() = "Repository for [${_db.toString()}] - ${config.endpoint}"

  override var connectivityStatus: Int
    get() = _repositoryHelper.connectivityStatus
    set(newValue) {
      _repositoryHelper.connectivityStatus = newValue
    }

  override val clientState: Flow<DoorRepositoryReplicationClient.ClientState>
    get() = _repositoryHelper.clientState

  override val invalidationTracker: InvalidationTracker
    get() = _db.invalidationTracker

  override val dbVersion: Int
    get() = 1

  private val _RepDao: RepDao_Repo by lazy {
        RepDao_Repo(db, this, db.repDao, _httpClient, clientId, _endpoint)
      }


  override val repDao: RepDao
    get() =  _RepDao

  override val compositePkDao: CompositePkDao
    get() = throw IllegalStateException("CompositePkDao is not annotated with @Repository")

  private val _RepWithAttachmentDao: RepWithAttachmentDao_Repo by lazy {
        RepWithAttachmentDao_Repo(db, this, db.repWithAttachmentDao, _httpClient, clientId,
            _endpoint)
      }


  override val repWithAttachmentDao: RepWithAttachmentDao
    get() =  _RepWithAttachmentDao

  override fun clearAllTables(): Unit = throw
      IllegalStateException("Cannot use a repository to clearAllTables!")

  override suspend fun clearAllTablesAsync(): Unit = throw
      IllegalStateException("Cannot use this to run clearAllTablesAsync")

  override fun close() {
    _repositoryHelper.close()
  }

  override fun remoteNodeIdOrNull(): Long? = _repositoryHelper.remoteNodeIdOrNull()

  override fun remoteNodeIdOrFake(): Long = _repositoryHelper.remoteNodeIdOrFake()

  override fun createAllTables(): List<String> = throw
      IllegalStateException("Cannot use a repository to createAllTables!")

  public companion object {
    public const val _DB_NAME: String = "RepDb"
  }
}
